import {Injectable} from '@angular/core';
import {Country} from "../models/country.model";
import {BehaviorSubject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class CountriesService {

    countries: Country[];
    countries$: BehaviorSubject<Country[]> = new BehaviorSubject<Country[]>([]);

    constructor(private http: HttpClient) {
        this.http.get<Country[]>(environment.serverData + 'api_v1/countries').subscribe(countries => {
            this.countries = countries;
            this.countries$.next(this.countries)
        })

    }

    getCountryName(countryCode){
       return this.countries.filter(country => {return country.code === countryCode}).pop().name
    }

}
